import BaseService from './baseService';

class Rekonsiliasi extends BaseService {
    async getRekonsiliasi(opts = {}) {
        this.endPoint = '/rekonsiliasi';
        return this.get(opts);
    }
    async createRekonsiliasi(payload){
        this.endPoint = '/rekonsiliasi';
        return await this.post(payload); 
    }
}

export default new Rekonsiliasi();